define( function() {
	"use strict";

	return window.document;
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/document.js
// module id = 201
// module chunks = 37